import { Col, Divider, Row, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  Form,
  ModalItem,
  FormItem,
  InputItem,
  InputNumberItem,
  DatePickerItem,
  TextAreaItem,
  HeaderItem,
  BoxItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";

// Clonado (simplificado, solo lectura) de Pages/Panel/Lotes/VerLote/VerLote.js
class VerUnidadActivoFijo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    unidad: null,
    insumo: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarInformacionUnidad();
    }
  }

  consultarInformacionUnidad() {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/datosUnidadActivoFijo",
        { entradaSalidaId: this.props.entradaSalidaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error al consultar la información de la unidad");
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false, unidad: res.data.unidad, insumo: res.data.insumo });
          this.formRef.current.setFieldsValue({
            ...res.data.unidad,
            fechaAdquisicion: res.data.unidad.fechaAdquisicion ? moment(res.data.unidad.fechaAdquisicion) : null,
            fechaCompra: res.data.unidad.fechaCompra ? moment(res.data.unidad.fechaCompra) : null,
            fechaFabricacion: res.data.unidad.fechaFabricacion ? moment(res.data.unidad.fechaFabricacion) : null,
            fechaInicioDepreciacion: res.data.unidad.fechaInicioDepreciacion ? moment(res.data.unidad.fechaInicioDepreciacion) : null,
            fechaBaja: res.data.unidad.fechaBaja ? moment(res.data.unidad.fechaBaja) : null,
          });
        }
      });
  }

  cerrarVerUnidadActivoFijo() {
    this.props.cerrarVerUnidadActivoFijo();
    this.formRef.current.resetFields();
  }

  render() {
    const unidad = this.state.unidad || {};
    const porcentajeDepreciado = unidad.costo ? Math.round(((unidad.depreciacionAcumulada || 0) / unidad.costo) * 100) : 0;
    return (
      <ModalItem
        title="Ver Unidad de Activo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarVerUnidadActivoFijo.bind(this)}
        paddingTop
        width={900}
      >
        <Divider>Unidad — {this.state.insumo?.descripcion}</Divider>
        <Form
          ref={this.formRef}
          name="verUnidadActivoFijo"
          layout
          bottom={
            <ButtonItem type="primary" onClick={() => this.cerrarVerUnidadActivoFijo()} rojo style={{ display: "block", margin: "0 0 0 auto" }}>
              Cerrar
            </ButtonItem>
          }
        >
          <Row>
            <Col span={12}>
              <FormItem label="Serie" name="serieActivo" margin tooltip={{ title: "Prefijo de la serie de esta unidad." }}>
                <InputItem disabled placeholder="Serie" />
              </FormItem>
              <FormItem label="Folio" name="numero" margin tooltip={{ title: "Consecutivo de folio de esta unidad." }}>
                <InputItem disabled placeholder="Folio" />
              </FormItem>
              <FormItem label="Fecha de Adquisición" name="fechaAdquisicion" margin tooltip={{ title: "Cuándo entró este activo a operar/inventario." }}>
                <DatePickerItem disabled style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
              <FormItem label="Fecha Compra" name="fechaCompra" margin tooltip={{ title: "Fecha de la orden/factura de compra." }}>
                <DatePickerItem disabled style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
              <FormItem label="Fecha Fabricación" name="fechaFabricacion" margin tooltip={{ title: "Fecha de fabricación reportada por el fabricante." }}>
                <DatePickerItem disabled style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
              <FormItem label="Fecha Inicio Depreciación" name="fechaInicioDepreciacion" margin tooltip={{ title: "Desde cuándo corre la depreciación de esta unidad." }}>
                <DatePickerItem disabled style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Ubicación Física" name="ubicacionFisica" margin tooltip={{ title: "Dónde está físicamente el activo." }}>
                <InputItem disabled placeholder="Ubicación física" />
              </FormItem>
              <FormItem label="Fabricante" name="fabricante" margin tooltip={{ title: "Fabricante del equipo/bien." }}>
                <InputItem disabled placeholder="Fabricante" />
              </FormItem>
              <FormItem label="Proveedor" name="proveedor" margin tooltip={{ title: "Proveedor que vendió esta unidad." }}>
                <InputItem disabled placeholder="Proveedor" />
              </FormItem>
              <FormItem label="Orden de Compra" name="ordenDeCompra" margin tooltip={{ title: "Referencia a la orden de compra/factura relacionada." }}>
                <InputItem disabled placeholder="Orden de compra" />
              </FormItem>
              {unidad.dadoDeBaja && (
                <FormItem label="Motivo de Baja" name="motivoBaja" margin>
                  <InputItem disabled placeholder="Motivo" />
                </FormItem>
              )}
            </Col>
          </Row>
          <HeaderItem>DEPRECIACIÓN</HeaderItem>
          <BoxItem>
            <Row>
              <Col span={8}>
                <FormItem label="Costo" margin tooltip={{ title: "Costo de adquisición real de esta unidad — es el valor sobre el que se calcula la depreciación." }}>
                  <InputNumberItem disabled dinero value={unidad.costo} />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Depreciación Acumulada" margin tooltip={{ title: "Suma de todo lo depreciado a la fecha en las corridas periódicas." }}>
                  <InputNumberItem disabled dinero value={unidad.depreciacionAcumulada} />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Valor en Libros" margin tooltip={{ title: "Costo − Depreciación Acumulada. Es lo que 'vale' el activo contablemente en este momento." }}>
                  <InputNumberItem disabled dinero value={unidad.valorEnLibros} />
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <span>{porcentajeDepreciado}% depreciado — {unidad.numeroPeriodosDepreciados || 0} de {unidad.numeroPeriodosTotales || 0} periodos. Depreciación anual: {unidad.porcentajeDepreciacionAnualActivo != null ? `${unidad.porcentajeDepreciacionAnualActivo}%` : "-"}. Fórmula: Depreciación anual = (Costo − Valor Residual) × Depreciación Anual %.</span>
              </Col>
            </Row>
          </BoxItem>
          <HeaderItem>OBSERVACIONES</HeaderItem>
          <BoxItem>
            <FormItem name="observaciones" margin labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
              <TextAreaItem disabled placeholder="Observaciones" />
            </FormItem>
          </BoxItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerUnidadActivoFijo);
